export class BasicSensorPosRef {

    public uid: string;
    public count: number;
    public sensorSystemName: string;
}
